import { memo } from "react";
import Box from "@mui/material/Box";
import { ImageSet } from "@setting";
import "./style.css";
// import GOOGLE_MAP_API_KEY from '../../constants/API_KEY';

function SplashScreen() {
	return (
		<div id="fuse-splash-screen">
			<div className="logo">
				<img
					width="128"
					src={ImageSet.AppIcon}
					alt="logo"
					style={{ borderRadius: "50%" }}
				/>
			</div>
			<Box
				id="spinner"
				sx={{
					"& > div": {
						backgroundColor: "palette.primary.light",
					},
				}}>
				<div className="bounce1" />
				<div className="bounce2" />
				<div className="bounce3" />
			</Box>
		</div>
	);
}

export default memo(SplashScreen);
